<template>
  <v-dialog
    :value="isInfoDialogOpen"
    max-width="700px"
    persistent
  >
    <v-card class="pa-4">
      <div class="d-flex flex-row-reverse mr-2">
        <v-btn
          icon
          small
          @click="closeDialog"
        >
          <v-icon size="22">
            {{ icons.mdiClose }}
          </v-icon>
        </v-btn>
      </div>

      <v-card-title class="justify-center text-h5">
        {{ edit ? 'Editar' : 'Criar' }} Título
      </v-card-title>

      <v-card-text class="mt-8">
        <v-form
          ref="form"
          v-model="valid"
          class="multi-col-validation"
          @submit.prevent="handleSubmit"
        >
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="faqData.nome"
                outlined
                dense
                :rules="[validators.required]"
                label="Título"
                hide-details="auto"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="faqData.descricao"
                outlined
                dense
                label="Subtítulo"
                hide-details="auto"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              class="d-flex justify-center"
            >
              <v-btn
                color="primary"
                class="mr-3"
                type="submit"
              >
                <v-progress-circular
                  v-if="loading"
                  class="mx-3"
                  indeterminate
                  color="secundary"
                />

                <span v-else>{{ edit ? 'Editar' : 'Criar' }}</span>
              </v-btn>

              <v-btn
                color="secondary"
                class="mb-1"
                outlined
                type="reset"
                @click="closeDialog"
              >
                Cancelar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import { mdiClose } from '@mdi/js'
import { required } from '@core/utils/validation'
import FaqService from '@/services/modules/FaqService'

export default {
  emits: ['refetch-data'],

  props: {
    items: {
      type: Object,
      default: () => {},
    },
    isInfoDialogOpen: {
      type: Boolean,
      required: false,
    },
    edit: {
      type: Boolean,
      required: false,
    },
  },

  setup(props, { emit }) {
    const faqData = ref({
      id: '',
      nome: '',
      descricao: '',
    })
    const faqBlank = ref({
      id: '',
      nome: '',
      descricao: '',
    })

    const form = ref(null)
    const valid = ref(false)
    const loading = ref(false)

    const validate = () => {
      form.value.validate()
    }

    const resetForm = () => {
      form.value.reset()
    }
    const closeDialog = () => {
      emit('update:isInfoDialogOpen', false)
      faqData.value = faqBlank.value
      resetForm()
    }

    watch(
      () => props.isInfoDialogOpen,
      () => {
        if (props.edit) {
          faqData.value.id = props.items.id
          faqData.value.nome = props.items.nome
          faqData.value.descricao = props.items.descricao
        } else {
          faqData.value = faqBlank.value
        }
      },
    )

    const handleSubmit = async () => {
      if (valid.value) {
        try {
          loading.value = true

          if (props.edit) {
            await FaqService.atualizarTopico(faqData.value)
          } else {
            await FaqService.criarTopico(faqData.value)
          }

          loading.value = false
          emit('refetch-data')
          closeDialog()
        } catch (error) {
          loading.value = false
        }
      } else {
        validate()
      }
    }

    return {
      faqData,
      form,
      valid,
      loading,
      faqBlank,
      closeDialog,
      handleSubmit,
      validate,
      validators: {
        required,
      },
      icons: {
        mdiClose,
      },
    }
  },
}
</script>
